var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "truck"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/truck"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 2.19V8.4225C11 9.1875 10.3775 9.81 9.6125 9.81H2.75C2.3375 9.81 2 9.4725 2 9.06V4.2675C2 2.7375 3.2375 1.5 4.7675 1.5H10.3025C10.6925 1.5 11 1.8075 11 2.19Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 2.19V8.4225C11 9.1875 10.3775 9.81 9.6125 9.81H2.75C2.3375 9.81 2 9.4725 2 9.06V4.2675C2 2.7375 3.2375 1.5 4.7675 1.5H10.3025C10.6925 1.5 11 1.8075 11 2.19Z",
    fill: "black",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.625 11.625C16.835 11.625 17 11.79 17 12V12.75C17 13.995 15.995 15 14.75 15C14.75 13.7625 13.7375 12.75 12.5 12.75C11.2625 12.75 10.25 13.7625 10.25 15H8.75C8.75 13.7625 7.7375 12.75 6.5 12.75C5.2625 12.75 4.25 13.7625 4.25 15C3.005 15 2 13.995 2 12.75V11.25C2 10.8375 2.3375 10.5 2.75 10.5H9.875C10.91 10.5 11.75 9.66 11.75 8.625V4.5C11.75 4.0875 12.0875 3.75 12.5 3.75H13.13C13.67 3.75 14.165 4.0425 14.435 4.5075L14.915 5.3475C14.9825 5.4675 14.8925 5.625 14.75 5.625C13.715 5.625 12.875 6.465 12.875 7.5V9.75C12.875 10.785 13.715 11.625 14.75 11.625H16.625Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.625 11.625C16.835 11.625 17 11.79 17 12V12.75C17 13.995 15.995 15 14.75 15C14.75 13.7625 13.7375 12.75 12.5 12.75C11.2625 12.75 10.25 13.7625 10.25 15H8.75C8.75 13.7625 7.7375 12.75 6.5 12.75C5.2625 12.75 4.25 13.7625 4.25 15C3.005 15 2 13.995 2 12.75V11.25C2 10.8375 2.3375 10.5 2.75 10.5H9.875C10.91 10.5 11.75 9.66 11.75 8.625V4.5C11.75 4.0875 12.0875 3.75 12.5 3.75H13.13C13.67 3.75 14.165 4.0425 14.435 4.5075L14.915 5.3475C14.9825 5.4675 14.8925 5.625 14.75 5.625C13.715 5.625 12.875 6.465 12.875 7.5V9.75C12.875 10.785 13.715 11.625 14.75 11.625H16.625Z",
    fill: "black",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 16.5C7.32843 16.5 8 15.8284 8 15C8 14.1716 7.32843 13.5 6.5 13.5C5.67157 13.5 5 14.1716 5 15C5 15.8284 5.67157 16.5 6.5 16.5Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 16.5C7.32843 16.5 8 15.8284 8 15C8 14.1716 7.32843 13.5 6.5 13.5C5.67157 13.5 5 14.1716 5 15C5 15.8284 5.67157 16.5 6.5 16.5Z",
    fill: "black",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.5C13.3284 16.5 14 15.8284 14 15C14 14.1716 13.3284 13.5 12.5 13.5C11.6716 13.5 11 14.1716 11 15C11 15.8284 11.6716 16.5 12.5 16.5Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.5C13.3284 16.5 14 15.8284 14 15C14 14.1716 13.3284 13.5 12.5 13.5C11.6716 13.5 11 14.1716 11 15C11 15.8284 11.6716 16.5 12.5 16.5Z",
    fill: "black",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 9.3975V10.5H14.75C14.3375 10.5 14 10.1625 14 9.75V7.5C14 7.0875 14.3375 6.75 14.75 6.75H15.7175L16.805 8.655C16.9325 8.88 17 9.135 17 9.3975Z",
    fill: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9.3975V10.5H14.75C14.3375 10.5 14 10.1625 14 9.75V7.5C14 7.0875 14.3375 6.75 14.75 6.75H15.7175L16.805 8.655C16.9325 8.88 17 9.135 17 9.3975Z",
    fill: "black",
    fillOpacity: 0.2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckPackage);
export default __webpack_public_path__ + "static/media/truck-package.597719f627dd64bbc1d648a14ec179f1.svg";
export { ForwardRef as ReactComponent };